import { toast } from 'react-toastify';
import { useParams } from 'react-router';

import { useStore } from '../../../../../context/store';
import { ConfirmContainer } from '../../../../../components/modal/ConfirmContainer';
import { Static } from '../../../../../static';
import agent from '../../../../../api/agent';

const MainFooter = () => {
	const { modalStore } = useStore();
	const { id } = useParams();

	const onUnsubscribeConfirm = () => {
		modalStore.openModal(
			<ConfirmContainer
				title=''
				message={Static.unsubscribeDialog}
				btnOkText=''
				btnCancelText=''
				btnStyle='app-btn-success'
				titleStyle='black'
				handleConfirm={async () => {
					agent.Document.unsubscribe(Number(id))
						.then((res) => {
							if (res === true) toast.success(Static.unsubscribeCompleted);
							else toast.error(Static.unsubscribeFailed);
						})
						.catch(() => toast.error(Static.anUnexpectedErrorHasOccurred));
				}}
				handleDecline={modalStore.closeModal}
			/>,
		);

		agent.Tracking.track(
			Static.onUnsubscribeConfirm + ' ' + Static.fromMainFooterComponent,
		);
	};

	const onLinkedinClick = () => {
		agent.Tracking.track(
			Static.onLinkedinClick + ' ' + Static.fromMainFooterComponent,
			Static.urlDemoLinkedin,
		);
	};

	const onYoutubeClick = () => {
		agent.Tracking.track(
			Static.onYoutubeClick + ' ' + Static.fromMainFooterComponent,
			Static.urlDemoYouTube,
		);
	};

	return (
		<div
			id='main-footer'
			className='row mt-3 mt-md-5 pt-4 pb-4 pt-md-5 pb-md-5 footer'
		>
			<div className='col-md-6'>
				<div className='ms-5'>
					<h3 className='white'>Contatti</h3>
					<h5 className='white app-no-weight'>www.prtspa.com</h5>
					<h5 className='white app-no-weight'>info@prtspa.com</h5>
					<h5 className='white app-no-weight'>(+39) 011 32 07 911</h5>
					<h5 className='white app-no-weight'>
						Via Frejus, 5 - 10092 Beinasco TO
					</h5>
				</div>
			</div>

			<div className='col-md-6'>
				<div className='ms-5'>
					<h3 className='white'>Seguici su</h3>

					<a
						className='app-social-link me-3'
						href={Static.urlDemoLinkedin}
						target='_blank'
						rel='noopener noreferrer'
						onClick={onLinkedinClick}
						aria-label='Apri LinkedIn'
					>
						<img
							className='app-img-social'
							src='/images/shared/LinkedinWhite.png'
							alt='LinkedIn'
						/>
					</a>

					<a
						className='app-social-link'
						href={Static.urlDemoYouTube}
						target='_blank'
						rel='noopener noreferrer'
						onClick={onYoutubeClick}
						aria-label='Apri YouTube'
					>
						<img
							className='app-img-social'
							src='/images/shared/YouTubeWhite.png'
							alt='YouTube'
						/>
					</a>

					<p className='pt-2 pe-4 pt-md-3 pb-0 mb-0 white'>
						<button
							type='button'
							className='app-inline-button white'
							onClick={onUnsubscribeConfirm}
						>
							<strong>Clicca qui </strong>
						</button>{' '}
						se non vuoi più ricevere la tua bolletta in formato elettronico.
					</p>
				</div>
			</div>
		</div>
	);
};

export default MainFooter;
